const profiles = [
  { name: "ADMINISTRADOR", slug: "admin" },
  { name: "DIRETOR", slug: "diretor" },
  { name: "EQUIPE MÉDICA", slug: "equipe_medica" }, 
  { name: "PLANTONISTA CET/COSET", slug: "plantonista_cet_coset" },
  { name: "PLANTONISTA OPO/EDOT", slug: "plantonista_opo_edot" },
  { name: "PLANTONISTA BO", slug: "plantonista_bo" },
  { name: "GESTOR HEMOBA", slug: "gestor_hemoba" },
  { name: "SESAB COSET", slug: "sesab_coset" },
  { name: "TEC. CENTRAL", slug: "tec_central" },
  { name: "TEC. BANCO DE OLHOS", slug: "tec_banco_olhos" },
  { name: "TEC. CAPTADOR - OPC", slug: "tec_captador_opc" },
  { name: "TÉC. HEMOBA IMUNO", slug: "tec_hemoba_imuno" },
  { name: "TÉC. HEMOBA SOROLOGIA", slug: "tec_hemoba_sorologia" },
  { name: "PLANTONISTA OPC", slug: "plantonista_opc" },
];
 
export function profileSlug(profileName) {
  const profile = profiles.find(p => p.name === profileName);

  if(!profile) { 
    return null;
  }

  return profile.slug;
}
 
export function getProfileNameBySlug(slug) {
  const profile = profiles.find(p => p.slug === slug);

  if(!profile) { 
    return null;
  }

  return profile.name;
}

export default profileSlug;